import { Alert } from 'baseui/icon'
import { StatefulTooltip } from 'baseui/tooltip'
import useUnsavedChangesBadge from './useUnsavedChangesBadge'
import { Badge } from './styled-components'

const UnsavedChangesBadge = () => {
  const { hidden, label, onKeyDown } = useUnsavedChangesBadge()

  if (hidden) return null

  return (
    <StatefulTooltip content={label} popoverMargin={8}>
      <Badge role='img' tabIndex={0} aria-label={label} onKeyDown={onKeyDown}>
        <Alert size={16} />
      </Badge>
    </StatefulTooltip>
  )
}

export default UnsavedChangesBadge
